<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./DeclaracaoInssContainerCadastro"
export default {
  name: "DeclaracaoInssCadastro",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssCadastro.vue